import type { TawktoConfig } from '@app/hooks/useTawkto'

/** Match a configured route prefix without treating `/` as “every path”. */
export const routeMatchesPrefix = (pathname: string, route: string): boolean => {
  const prefix = route.replace(/\/+$/, '') || '/'
  if (prefix === '/') {
    return pathname === '/'
  }
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}

/** Whether the custom launcher should render on this path. */
export const isSupportChatLauncherVisible = (
  pathname: string,
  config: Pick<TawktoConfig, 'allowedRoutes' | 'hiddenRoutes'>,
): boolean => {
  if (config.allowedRoutes.length > 0) {
    return config.allowedRoutes.some((route) => routeMatchesPrefix(pathname, route))
  }
  return !config.hiddenRoutes.some((route) => routeMatchesPrefix(pathname, route))
}
